import React from "react";
import Navbar from "./Navbar";

const About = () => {
  return (
    <>
      <Navbar />
      <div className="text-center mt-3">
        <h1>About Us Page.</h1>
      </div>
    </>
  );
};

export default About;
